import {FAQ} from 'attendee/Help/FAQ'
import Page from 'attendee/theme/Page'
import React from 'react'
import contactsImage from 'images/contacts.png'
import {Helmet} from 'react-helmet'
import {DEFAULT_OG_IMAGE, SITE_ORIGIN} from 'seo/siteMeta'
import {useI18n} from 'i18n/I18nContext'
import {withLocalePath} from 'i18n/localePaths'
import {routes} from 'routes/routes'

export function Help() {
  const {locale, t} = useI18n()
  const pageUrl = `${SITE_ORIGIN}${withLocalePath(locale, routes.help)}`

  return (
    <Page>
      <>
        <Helmet>
          <title>{t('help.metaTitle')}</title>
          <meta name="description" content={t('help.metaDescription')} />
          <link rel="canonical" href={pageUrl} />
          <meta property="og:title" content={t('help.ogTitle')} />
          <meta property="og:description" content={t('help.ogDescription')} />
          <meta property="og:url" content={pageUrl} />
          <meta property="og:image" content={DEFAULT_OG_IMAGE} />
          <meta property="og:image:secure_url" content={DEFAULT_OG_IMAGE} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={t('help.ogTitle')} />
          <meta
            name="twitter:description"
            content={t('help.ogDescription')}
          />
          <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
        </Helmet>
        <section className="contact_section dark_light_class pt-55 pb-150">
          <div className="container">
            <h2 className="section__title mb-35">
              {t('help.faqHeadingBefore')}{' '}
              <span className="text__highlight">
                {' '}
                {t('help.faqHeadingHighlight')}
              </span>
            </h2>

            <FAQ />

            <h2 className="section__title mb-35 mt-80">
              {t('help.contactHeadingBefore')}{' '}
              <span className="text__highlight">
                {' '}
                {t('help.contactHeadingHighlight')}
              </span>
            </h2>

            <div className="row g-4">
              <div className=" col-12 col-lg-6">
                <img src={contactsImage} width="100%" alt="" />
              </div>

              <div className="col-12 col-lg-6">
                <ul className="contact_info_list style_2 ps-lg-4 unordered_list_block">
                  <li>
                    <strong>{t('help.phoneLabel')}</strong>
                    {t('help.phoneHidden')}
                  </li>
                  <li>
                    <strong>{t('help.emailLabel')}</strong>
                    <a
                      href="mailto:support@eventa.tv"
                      target="_blank"
                      rel="noreferrer"
                    >
                      support@eventa.tv
                    </a>
                  </li>
                  <li>
                    <strong>{t('help.hoursLabel')}</strong>
                    <span>{t('help.hoursValue')}</span>
                  </li>
                  <li>
                    <strong>{t('help.followLabel')}</strong>
                    <div className="social_icon unordered_list">
                      <div className={'footer__social'}>
                        <a
                          href="https://www.facebook.com/eventatv"
                          target="_blank"
                          rel="noreferrer"
                          aria-label="facebook"
                        >
                          <i className="fa-brands fa-facebook"></i>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </>
    </Page>
  )
}
